import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	warningsButtonLabel: {
		id: 'portfolio-3-portfolio.common.warning-details.warnings-button-label',
		defaultMessage: 'Warnings',
		description: 'It is the label of the "Warnings" icon button on the work items.',
	},
	openIssueModalButtonLabel: {
		id: 'portfolio-3-portfolio.common.warning-details.open-issue-modal-button-label.non-final',
		defaultMessage: 'Open issue create to resolve',
		description:
			'The label of the button in the warning details popup that opens the issue create modal.',
	},
	openTransitionScreenModalButtonLabel: {
		id: 'portfolio-3-portfolio.common.warning-details.open-transition-screen-modal-button-label.non-final',
		defaultMessage: 'Open transition screen to resolve',
		description:
			'The label of the button in the warning details popup that opens the transition screen modal.',
	},
});
